import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-instruction-entry',
  templateUrl: './instruction-entry.component.html',
  styleUrls: ['./instruction-entry.component.css']
})
export class InstructionEntryComponent implements OnInit {
  title = "Instruction-Entry";
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/accountmaster/instruction-entry/instruction-entry.component.ts